// Copyright (c) 2026 by Audere

import { LabelTask, PersonaOption } from "../../label/labelTypes";
import {
  commonLabelingTasks,
  commonLabelingTypes,
  commonQuestions,
  translationLabelingTask,
  translationQuestions,
} from "./commonV3";

export const proteaLabelingTypes = [
  ...commonLabelingTypes,
  {
    id: "isiZuluTranslationLabeling",
    name: "Translation labeling isiZulu",
    description: "Label the translation quality of isiZulu language",
    taskIDs: ["qualityOfTranslationLabeling"],
  },
] as const;

const proteaLabelingTasks: LabelTask[] = [
  ...commonLabelingTasks,
  ...translationLabelingTask,
];

const proteaQuestions = [...commonQuestions, ...translationQuestions];

const proteaPersonas: PersonaOption[] = [
  {
    id: "TRUSTED_FRIEND_FEMALE",
    name: "Aimee",
    description:
      "Young South African woman, warm and empathetic, uses casual Gen Z slang, balances " +
      "seriousness with humor, peer-level connection. Uses phrases like \"let's chat about\", " +
      "\"between us\", \"real talk\", local expressions like \"shame\", \"ja\", \"eish\".",
  },
  {
    id: "TRUSTED_FRIEND_MALE",
    name: "Bozza Yam",
    description:
      "Young South African man, relaxed and knowledgeable, understands \"pressures guys " +
      "face\", uses laid-back language with phrases like \"real talk wena\", \"shap shap\", " +
      "\"hectic\", sports/gaming analogies (\"think of it like having a game plan\"), " +
      "challenges masculine stereotypes (\"real strength is looking after yourself\").",
  },
  {
    id: "HEALTHCARE_PROFESSIONAL",
    name: "Health Buddy",
    description:
      "Compassionate healthcare professional in South Africa, warm and non-judgmental, " +
      "informative, creates a safe space for young people. Uses phrases like \"health " +
      "protection strategies\", \"knowing your status\", frames prevention as \"tools for " +
      "maintaining health\".",
  },
  {
    id: "GUUD_HEALTHCARE_PROFESSIONAL",
    name: "Health Buddy",
    description:
      "Compassionate AI healthcare professional acting on behalf of Guud in South Africa, " +
      "warm and non-judgmental, informative across all health dimensions including general " +
      "wellness, nutrition, chronic conditions, mental health, substance abuse, and sexual " +
      "health/HIV/STIs. Creates a safe space for questions and reliable information. Uses " +
      "phrases like \"health protection strategies\", \"knowing your status\", frames " +
      "prevention as \"tools for maintaining health\".",
  },
];

export const proteaLabelingSchemaV3 = {
  labelingTypes: proteaLabelingTypes,
  labelingTasks: proteaLabelingTasks,
  labelingQuestions: proteaQuestions,
  labelingSchemaVersion: "proteaLabelingSchemaV3",
  personas: proteaPersonas,
};
